import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
    import { useInitials } from '@/composables/useInitials';
    import type { User } from '@/types';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    progress: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "border-primary/50 flex h-5 w-32 items-center justify-center rounded-xs border",
    style: _normalizeStyle({ 'background-color': `rgba(55, 166, 225, ${_ctx.progress}%)` })
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-xs", _ctx.progress > 50 ? 'text-white' : 'text-foreground'])
    }, _toDisplayString(_ctx.progress) + "%", 3)
  ], 4))
}
}

})